
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 9.565a3.043 3.043 0 100-6.087 3.043 3.043 0 000 6.087zM16.087 11.304a2.174 2.174 0 100-4.347 2.174 2.174 0 000 4.347zM3.975 11.304a2.174 2.174 0 100-4.347 2.174 2.174 0 000 4.347zM10 10.435a5.659 5.659 0 00-5.652 5.652c0 .24.194.435.434.435h10.435c.24 0 .435-.195.435-.435A5.659 5.659 0 0010 10.435zM4.724 12.268a3.903 3.903 0 00-.811-.094A3.918 3.918 0 000 16.087c0 .24.195.435.435.435h3.123a1.29 1.29 0 01-.08-.435c0-1.427.466-2.745 1.246-3.82zM16.087 12.174c-.275 0-.546.037-.812.094a6.481 6.481 0 011.246 3.819c0 .153-.03.298-.08.435h3.124c.24 0 .435-.195.435-.435a3.918 3.918 0 00-3.913-3.913z"}})])
          )
        }
      }
    